import React, { useEffect, useState, useRef } from "react";
import "../Pages/CSS/autotype.css";

function Home() {
  const [lines, setLines] = useState([]);
  const typingInterval = useRef(null);
  const sentenceIndex = useRef(0);

  const customSentences = [
    "Hello, world!",
    "Welcome to my website.",
    "Freelancing globaly.",
    "FETCHING CREATIVITY!",
    "I hope you like it here.",
    "Feel free to explore.",
    "Making work easy for you.",
    "loading...",
    "Enjoy the experience.",
    "COMPILING DESIGN DREAMS!"
  ];

  useEffect(() => {
    const addLine = () => {
      const currentSentence = customSentences[sentenceIndex.current % customSentences.length];
      sentenceIndex.current += 1;

      setLines((prevLines) => {
        if (prevLines.length >= 10) {
          return [...prevLines.slice(1), currentSentence];
        }
        return [...prevLines, currentSentence];
      });
    };

    typingInterval.current = setInterval(addLine, 2000);

    return () => {
      clearInterval(typingInterval.current);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="typing-box">
      {lines.map((line, index) => (
        <span key={index} className="line" style={{ '--index': index }}>
          {line}
        </span>
      ))}
    </div>
  );
}

export default Home;
